import {SETTINGS, MANAGEMENT, APPOINTMENTS, ACTIVATION, CLINICIANS, VOUCHER, ANALYTICS} from './svgIcons';
import StorageService from "services/StorageService";
import { SUPER_ADMIN } from "./roles";
import { USER } from "./storageConstants";

const isUserSuperAdmin = new StorageService().getValueByKey(USER)?.role === SUPER_ADMIN;

export const sidebarLinks = [
    {to: "/appointments", label: "Appointments", icon: APPOINTMENTS},
    {to: "/patients-management", label: "Patients management", icon: MANAGEMENT},
    {to: "/activation-code", label: "Activation code", icon: ACTIVATION},
    {to: "/voucher", label: "Voucher code", icon: VOUCHER},
    {to: "/clinicians-management", label: "Clinicians management", icon: CLINICIANS},
    // { to: "/user-analytics", label: "User analytics", icon: ANALYTICS },
    {to: "/settings", label: "Settings", icon: SETTINGS}
];

if (isUserSuperAdmin) {
    sidebarLinks.push({to: "/statistics", label: "Statistics", icon: ANALYTICS});
}